import { render, staticRenderFns } from "./ServiceTel.vue?vue&type=template&id=a10d0754&scoped=true&"
import script from "./ServiceTel.vue?vue&type=script&lang=js&"
export * from "./ServiceTel.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTel.vue?vue&type=style&index=0&id=a10d0754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10d0754",
  null
  
)

export default component.exports